document.addEventListener('DOMContentLoaded', () => {
  const section = document.getElementById('faq-section');
  const tabTitles = section.querySelectorAll('.product-tab-title');
  const deviceCompBtn = document.querySelector('.device__comp-btn--container .device__comp-button');

  if (!tabTitles.length) return;

  function triggerDeviceCompPopup() {
    if (!deviceCompBtn) return;
    deviceCompBtn.click();
  }

  function applyPopupCursorStyles() {
    section.querySelectorAll('.faq-card[data-popup] .faq-answer strong').forEach((txt) => {
      txt.classList.add('cursor-pointer');
    });
  }

  applyPopupCursorStyles();

  section.addEventListener('faq:swap', applyPopupCursorStyles);

  // Delegated: works on dynamically swapped containers
  section.addEventListener('click', (e) => {
    const txt = e.target.closest('.faq-card[data-popup] .faq-answer strong');
    if (txt) triggerDeviceCompPopup();
  });

  const activateTab = (tab) => {
    const targetId = `${tab.id}-container`;
    const targetDescription = document.getElementById(targetId);

    tabTitles.forEach((t) => t.classList.remove('tab-active'));
    // Re-query so swapped containers are included
    section.querySelectorAll('.question-container').forEach((desc) => {
      desc.classList.remove('container-active');
      desc.setAttribute('aria-selected', 'false');
    });

    tab.classList.add('tab-active');
    if (targetDescription) {
      targetDescription.classList.add('container-active');
      targetDescription.setAttribute('aria-selected', 'true');
    }

    tab.parentElement.scrollTo({
      left: tab.offsetLeft - tab.parentElement.offsetWidth / 2 + tab.offsetWidth / 2,
      behavior: 'smooth',
    });
  };

  tabTitles.forEach((tab) => {
    tab.addEventListener('click', () => activateTab(tab));
  });

  // Delegated: works on dynamically swapped containers
  section.addEventListener('click', (e) => {
    const question = e.target.closest('.faq-question');
    if (!question) return;

    section.querySelectorAll('.faq-question').forEach((q) => {
      if (q !== question) {
        q.closest('.faq-card').querySelector('.faq-answer').classList.remove('answer-active');
      }
    });

    question.closest('.faq-card').querySelector('.faq-answer').classList.toggle('answer-active');
    question.classList.toggle('question-active');
  });
});
